import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-report-output-container',
    styleUrls: ['./report-output-container.component.scss'],
    templateUrl: './report-output-container.component.html',
    standalone: false
})
// eslint-disable-next-line @typescript-eslint/naming-convention
export class ReportOutputContainerComponent<V extends string> {
   //<T extends ChartDataPoint | ChartSeriesDataPoint, V extends string> implements OnChanges, OnInit, ReportOutputContainer<V>
   // @Input() charts: ChartConfig<T>[];
   // @Input() chartData: T[];
   // /**
   //  * The view mode for the report. The view mode is assumed to be an enum, with values like:
   //  * * "Full" renders the full report.
   //  * * "SomeChart" renders a specific chart.
   //  * * "SomeOtherChart" renders a different specific chart.
   //  *
   //  * The view mode should be used as the `id` for the chart config objects set on this component
   //  * so that the correct chart can be rendered.
   //  */
   @Input() viewMode?: V;
   // @Input() maxGoal: number | null;
   // @Output() viewModeChange = new EventEmitter<V | null>();
   // visibleCharts: ChartCollection = {};
   // /**
   //  * A cache of charts that have previously been processed.
   //  * Used to avoid processing the same chart multiple times.
   //  */
   // private processedCharts: ChartCollection = {};
   // private destroyed$ = new Subject<void>();
   // private includeChartsParameterValue = true;
   // constructor(
   //    private reportOutput: ReportOutputComponent,
   //    private scrollDispatcher: ScrollDispatcher,
   //    private elementRef: ElementRef
   // ) {}
   // ngOnInit(): void {
   //    this.reportOutput.report$.pipe(takeUntil(this.destroyed$)).subscribe((report: any) => {
   //       this.includeChartsParameterValue = this.getIncludeChartsParamValue(report);
   //       this.handleChange();
   //    });
   //    this.reportOutput.registerOutputContainer(this);
   // }
   // ngOnChanges(changes: SimpleChanges): void {
   //    if (changes.charts) {
   //       this.processedCharts = {};
   //       this.visibleCharts = {};
   //    }
   //    if (changes.charts || changes.viewMode) {
   //       this.handleChange();
   //    }
   // }
   // onExpand(chart: ChartData): void {
   //    this.viewModeChange.emit(chart.id as V);
   //    const scrollContainers = this.scrollDispatcher.getAncestorScrollContainers(this.elementRef);
   //    scrollContainers[scrollContainers.length - 1].scrollTo({ behavior: 'smooth', top: 0 });
   // }
   // onShowFullReport(): void {
   //    this.viewModeChange.emit(null);
   // }
   // private handleChange() {
   //    // if inputs haven't been set yet, don't process charts unnecessarily
   //    if (!this.charts) {
   //       return;
   //    }
   //    if (!this.includeChartsParameterValue) {
   //       this.visibleCharts = {};
   //       return;
   //    }
   //    if (this.viewMode && this.processedCharts[this.viewMode]) {
   //       this.visibleCharts = { [this.viewMode]: this.processedCharts[this.viewMode] };
   //       return;
   //    }
   //    const chartConfig = this.charts.find((c) => {
   //       return c.id === this.viewMode;
   //    });
   //    // The absence of the viewMode in the chart config array is assumed to mean that the
   //    // view mode is set to "Full", indicating that the report is intended
   //    // to show the entire report, including all of its charts.
   //    // We don't explicitly check for the string "Full" in case there are more complex
   //    // requirements around report view modes.
   //    if (!chartConfig && this.charts[0].id !== 'AgentAverageWeeklyChart') {
   //       this.processAllCharts();
   //    } else if (chartConfig) {
   //       this.processChart(chartConfig);
   //    }
   //    if (this.charts[0].id === 'AgentAverageWeeklyChart') {
   //       this.processLineCharts();
   //    }
   // }
   // private processChart(chart: ChartConfig<T>) {
   //    switch (chart.type) {
   //       case ChartType.Bar:
   //          const newChart = buildBarCharts([chart], this.chartData, false)[chart.id];
   //          this.processedCharts[chart.id] = newChart;
   //          this.visibleCharts = { [chart.id]: newChart };
   //          break;
   //       case ChartType.Line:
   //          const newLineChart = buildLineCharts([chart], this.chartData, false, this.maxGoal)[chart.id];
   //          this.processedCharts[chart.id] = newLineChart;
   //          this.visibleCharts = { [chart.id]: newLineChart };
   //          break;
   //       default:
   //          throw new Error('Unknown chart type.');
   //    }
   // }
   // private processAllCharts() {
   //    const barCharts: ChartConfig<T>[] = [];
   //    const lineCharts: ChartConfig<T>[] = [];
   //    this.visibleCharts = {};
   //    Object.entries(this.charts).forEach(([key, chart]) => {
   //       if (this.processedCharts[key]) {
   //          this.visibleCharts[key] = this.processedCharts[key];
   //          return;
   //       }
   //       switch (chart.type) {
   //          case ChartType.Bar:
   //             barCharts.push(chart);
   //             break;
   //          default:
   //             throw new Error('Unknown chart type.');
   //       }
   //    });
   //    if (barCharts.length > 0) {
   //       this.visibleCharts = this.processedCharts = {
   //          ...this.processedCharts,
   //          ...buildBarCharts(barCharts, this.chartData, true),
   //       };
   //    } else if (lineCharts.length > 0) {
   //       this.visibleCharts = this.processedCharts = {
   //          ...this.processedCharts,
   //          ...buildLineCharts(lineCharts, this.chartData, true, this.maxGoal),
   //       };
   //    }
   // }
   // private processLineCharts() {
   //    const barCharts: ChartConfig<T>[] = [];
   //    const lineCharts: ChartConfig<T>[] = [];
   //    this.visibleCharts = {};
   //    Object.entries(this.charts).forEach(([key, chart]) => {
   //       if (this.processedCharts[key]) {
   //          this.visibleCharts[key] = this.processedCharts[key];
   //          return;
   //       }
   //       switch (chart.type) {
   //          case ChartType.Line:
   //             lineCharts.push(chart);
   //             break;
   //          default:
   //             throw new Error('Unknown chart type.');
   //       }
   //    });
   //    if (barCharts.length > 0) {
   //       this.visibleCharts = this.processedCharts = {
   //          ...this.processedCharts,
   //          ...buildBarCharts(barCharts, this.chartData, true),
   //       };
   //    } else if (lineCharts.length > 0) {
   //       this.visibleCharts = this.processedCharts = {
   //          ...this.processedCharts,
   //          ...buildLineCharts(lineCharts, this.chartData, true, this.maxGoal),
   //       };
   //    }
   // }
   // private getIncludeChartsParamValue(report: ReportOutputBase<any, any>): boolean {
   //    if (!report) {
   //       return false;
   //    }
   //    // Reports shouldn't be using different names for the `includeCharts` report report parameter,
   //    // but they could, so we search for the parameter by its ReportParameter type instead of searching
   //    // for one that's named "includeCharts".
   //    const parameters = Object.values(report.parameters);
   //    const includeChartsParam = parameters.find(this.isIncludeChartsParameter);
   //    if (!includeChartsParam) {
   //       return true;
   //    }
   //    return (includeChartsParam as any).value;
   // }
   // private isIncludeChartsParameter(param: any): boolean {
   //    return param?.parameterType === ReportParameters.IncludeCharts;
   // }
}
